module.exports = __webpack_public_path__ + "img/gzh.d17cb424.png";